import React, { useState, useEffect } from 'react';
import ChatWeb from './ChatWeb';
import ChatMobile from './ChatMobile';
import { useAppLayout } from '../contexts/AppLayoutContext';

type ChatProps = {
  hasNewMessages?: { [contactId: number]: boolean };
  setHasNewMessages?: (newState: { [contactId: number]: boolean } | ((prev: { [contactId: number]: boolean }) => { [contactId: number]: boolean })) => void;
  contacts?: any[];
  setContacts?: React.Dispatch<React.SetStateAction<any[]>>;
};

const Chat: React.FC<ChatProps> = (props) => {
  const layout = useAppLayout();
  const resolvedProps = {
    hasNewMessages: layout.unreadMessages,
    setHasNewMessages: layout.setUnreadMessages,
    contacts: layout.contacts,
    setContacts: layout.setContacts
  };
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      const userAgent = navigator.userAgent;
      const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      const isMobileDevice = mobileRegex.test(userAgent);
      const isSmallScreen = window.innerWidth <= 768;

      setIsMobile(isMobileDevice || isSmallScreen);
    };

    // Verificar inicialmente
    checkIsMobile();

    // Adicionar listener para mudanças de tamanho da tela
    const handleResize = () => {
      checkIsMobile();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Renderizar o componente apropriado baseado no dispositivo
  return isMobile ? <ChatMobile {...resolvedProps} /> : <ChatWeb {...resolvedProps} />;
};

export default Chat;